import React from "react";
import FullWrapper from "../../layouts-components__common-cases/full-wrapper";
import './style.sass'
const BlocksIcons = ({list, caseName = ''}) => {
    return (
        <FullWrapper caseName={caseName}>
            <div className="icon-block">
                {list && list.map((item) => (
                    <div className='icon-block__wr' key={item.title}>
                        <div className='icon-block__icon'>
                            <img src={item.icon} alt={item.title}/>
                        </div>
                        <div className='icon-block__text' dangerouslySetInnerHTML={{__html: item.title}}></div>
                    </div>
                ))}
            </div>
        </FullWrapper>
    )
}

export default BlocksIcons;